/**
 * Collection PDF visual theme — mirrors Collection PDF page / 2026 Matlib UI.
 * Pass as `theme` on POST /pdf once api.matlib.net applies it in pdf-collection.js.
 *
 * Backend reference: ../matlib2026-api/src/lib/pdf-collection.js (COLORS)
 * Preview HTML (optional): public/pdftemplate.html via POST /pdf/preview
 */
export const COLLECTION_PDF_THEME_VERSION = 1;

export const COLLECTION_PDF_THEME = {
  version: COLLECTION_PDF_THEME_VERSION,
  palette: {
    accent: "#00ffed",
    accentMuted: "#9aece5",
    pageBackground: "#111414",
    headerBackground: "#202727",
    headerBackgroundEnd: "#151c1c",
    headerBorder: "#00ffed2e",
    headerText: "#f4fffd",
    headerKicker: "#00ffed",
    headerDescription: "#aeb9b8",
    footerBackground: "#1a3434",
    footerText: "#c9f8f5",
    cardBorder: "#ffffff14",
    cardBackground: "#171b1b",
    cardFooterBackground: "#141a1a",
    cardTitle: "#f4fffd",
    cardDescription: "#9eb7b7",
    overlayText: "#fefefe",
    overlayShadow: "#000000",
    priceText: "#c6fff9",
    emptySwatch: "#243030",
  },
  typography: {
    brandLabel: "MATLIB",
    titleTransform: "uppercase",
    headerTitleSize: 16,
    headerKickerSize: 8,
    headerDescriptionSize: 8,
    cardTitleSize: 10,
    cardDescriptionSize: 8,
    vendorOverlaySize: 9,
    priceOverlaySize: 7,
    brandOverlaySize: 7,
    kickerLetterSpacingEm: 0.18,
    buttonLetterSpacingEm: 0.08,
  },
  layout: {
    cardsPerRow: 2,
    cardHeight: 214,
    swatchHeight: 168,
    cardRadius: 6,
    cardGutter: 8,
    pageMarginPercent: 0.05,
    headerHeight: 56,
    footerHeight: 28,
  },
};

/** Payload helper for POST /pdf */
export function getCollectionPdfTheme() {
  return COLLECTION_PDF_THEME;
}
